import React, { useEffect, useState } from "react";
import { getMerchant } from '../../helpers/ReduxHelpers';
import { apiConstants, getGeneric, postGeneric } from '../../common/constants';
import { useForm } from "react-hook-form";
import { Box, Button, FormControlLabel, Grid, Switch, Tooltip, Typography } from "@mui/material";
import { FormProvider, RHFTextField } from "../../common/hook-form";
import { LoadingButton } from "@mui/lab";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from 'yup'
import Loader from "../../common/Loader"
import { useSnackbar } from "notistack";
import ProzoDataGrid from "../../common/ProzoDataGrid";
import ConfirmDialog from "../../common/ConfirmDialog";
import { primaryTextSx, secondaryTextSx, cellStackSx } from '../orders/list2/cellStyles';
import { primaryBtnSx, secondaryBtnSx, filterBarSx } from '../../styles/patterns';
import { FONT, SIZE, WEIGHT } from '../../styles/foundation/typography';
import { NAVY, SUBTLE } from '../../styles/foundation/colors';

const CodEmail = () => {
    // const userToken = jwt_decode(getToken());
    // const merchantId = (userToken && userToken.merchantOid) ? userToken.merchantOid : "";

    const merchant = getMerchant();
    const merchantId = merchant.id ? merchant.id : ''

    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [merchantConfig, setMerchantConfig] = useState();
    const [isCODEnabled, setCODEnabled] = useState(false);
    const [reload, setReload] = useState(0);
    const [deleteConfirm, setDeleteConfirm] = useState(false);
    const [deleteData, setDeleteData] = useState();
    const [switchConfirm, setSwitchConfirm] = useState(false);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [page, setPage] = useState(0);


    const columns = [
        {
            field: 'emails',
            headerAlign: "left",
            hideSortIcons: true,
            headerName: 'Emails',
            flex: 1.2,
            minWidth: 250,
            align: 'left',
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}>
                        <Typography sx={primaryTextSx}>{row?.email}</Typography>
                    </Box>
                )
            },
        },
        {
            field: 'action',
            headerAlign: "left",
            hideSortIcons: true,
            headerName: 'Action',
            flex: 0.5,
            minWidth: 120,
            align: 'left',
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Button
                        onClick={() => handleCancelOrder(row)}
                        disabled={!isCODEnabled}
                        color="error"
                        variant="outlined"
                        size="small"
                    >
                        Delete
                    </Button>
                );
            },
        },
    ];

    const emailListRegExp = /^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,}\s*,\s*)*[\w+-.%]+@[\w-.]+\.[A-Za-z]{2,}$/

    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                email: Yup.string()
                    .matches(emailListRegExp, { message: 'Invalid email format', excludeEmptyString: true })
                    .required("Email is required!"),
            })
        ),
        defaultValues: {
            email: '',
        }
    })
    const { handleSubmit: handleSubmitForm, reset } = methods


    const postMerchantConfig = (payload) => {
        postGeneric(`${apiConstants.MERCHANT_DETAILS}/${merchantId}/codRemitComm`, payload).then(response => {
            enqueueSnackbar('Success', { variant: 'success' })
            reset()
            setReload(reload => reload + 1)
            setLoading(false)
        })
            .catch((err) => {
                console.error(err)
                enqueueSnackbar('Some error occurred', { variant: 'error' })
                setLoading(false)
            })
    }

    const onSubmit = (data) => {
        setLoading(true);
        const existingEmails = merchantConfig?.codRemittanceCommunication?.emails ?? [];
        const emailsArray = data.email.split(',').map(email => email.trim());
        const payload = {
            "enableWA": false,
            "enableSMS": false,
            "mobileNos": [],
            "enableEmail": true,
            "emails": [...existingEmails, ...emailsArray]
        }
        postMerchantConfig(payload)
    }

    const handleCancelOrder = (data) => {
        setDeleteData(data)
        setDeleteConfirm(true)
    }
    const handleDelete = () => {
        const index = merchantConfig?.codRemittanceCommunication?.emails.indexOf(deleteData.email);
        if (index !== -1) {
            merchantConfig?.codRemittanceCommunication?.emails.splice(index, 1);
        }
        const payload = {
            "enableWA": false,
            "enableSMS": false,
            "mobileNos": [],
            "enableEmail": true,
            "emails": [...merchantConfig?.codRemittanceCommunication?.emails]
        }
        postMerchantConfig(payload)
    }


    useEffect(() => {
        setLoading(true)
        getGeneric(`${apiConstants.MERCHANT_DETAILS}/${merchantId}`).then((res) => {
            setMerchantConfig(res.data);
            setLoading(false)
        }).catch((err) => {
            console.log(err)
            setLoading(false)
        })
    }, [merchantId, reload])


    const toggleEmail = () => {
        let payload = {
            "enableWA": false,
            "enableSMS": false,
            "mobileNos": [],
            "enableEmail": isCODEnabled ? false : true,
            "emails": merchantConfig?.codRemittanceCommunication?.emails
        }
        postMerchantConfig(payload)
    }

    useEffect(() => {
        setCODEnabled(merchantConfig?.codRemittanceCommunication?.enableEmail)
    }, [merchantConfig?.codRemittanceCommunication?.enableEmail])

    const handleSwitchConfirmation = (e) => {
        setSwitchConfirm(true);
    };
    const handleSwitchAction = () => {
        toggleEmail()
    };
    return (
        <>
            {(isLoading) && <Loader />}
            <ConfirmDialog
                title=''
                open={deleteConfirm}
                setOpen={setDeleteConfirm}
                disableButtons={merchantConfig?.codRemittanceCommunication?.emails?.length === 1}
                onConfirm={() => handleDelete()}>
                {merchantConfig?.codRemittanceCommunication?.emails?.length === 1 ? "Please disable via Toggle Switch" : "Are you sure you want to delete ?"}
            </ConfirmDialog>
            <ConfirmDialog
                title=''
                open={switchConfirm}
                setOpen={setSwitchConfirm}
                onConfirm={() => handleSwitchAction()}>
                Are you sure you want to change the email configuration?
            </ConfirmDialog>
            <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                    <Box sx={filterBarSx}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                            <Box>
                                <Typography sx={{ fontFamily: FONT, fontSize: SIZE.md, fontWeight: WEIGHT.semibold, color: NAVY }}>COD Email Configuration</Typography>
                                <Typography sx={{ fontFamily: FONT, fontSize: SIZE.xs, color: SUBTLE, mt: 0.5 }}>Configure email notifications for COD remittance</Typography>
                            </Box>
                            <Tooltip title={isCODEnabled ? "Disable COD Emails" : "Enable COD Emails"}>
                                <FormControlLabel
                                    control={<Switch checked={isCODEnabled} onChange={(e) => handleSwitchConfirmation(e)} disabled={!merchantConfig?.codRemittanceCommunication?.emails?.length > 0} sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#4caf50' }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#4caf50' } }} />}
                                    label={<Typography sx={{ fontFamily: FONT, fontSize: SIZE.xs, color: isCODEnabled ? '#4caf50' : SUBTLE }}>{isCODEnabled ? 'Enabled' : 'Disabled'}</Typography>}
                                    labelPlacement="start"
                                />
                            </Tooltip>
                        </Box>
                        <FormProvider methods={methods} onSubmit={handleSubmitForm(onSubmit)}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={4}>
                                    <RHFTextField
                                        name="email"
                                        label="Add Emails *"
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12} md={2} sx={{ display: 'flex', alignItems: 'center' }}>
                                    <LoadingButton loading={isLoading}
                                        type="submit"
                                        variant="contained"
                                        size="small"
                                        sx={primaryBtnSx}
                                    >Add</LoadingButton>
                                </Grid>
                            </Grid>
                        </FormProvider>
                    </Box>
                    <Grid item xs={12} sx={{ mt: 1 }}>
                        <ProzoDataGrid
                            columns={columns}
                            autoHeight={true}
                            rows={(merchantConfig && merchantConfig?.codRemittanceCommunication?.emails?.length > 0)
                                ? merchantConfig?.codRemittanceCommunication?.emails.map((email, index) => ({ id: index, email }))
                                : []
                            }
                            sizePerPage={sizePerPage}
                            setSizePerPage={setSizePerPage}
                            setPage={setPage}
                            page={page}
                            pagination={true}
                            paginationMode='client'
                            // rowCount={Number.MAX_VALUE}
                            rowCount={merchantConfig?.codRemittanceCommunication?.emails?.length || 0}
                            // hideCountNumber={true}
                            getRowId={(row) => row.id}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};

export default CodEmail;
